export function routingActionCreator(route) {
    return {
        type: route
    };
}
